import { render, staticRenderFns } from "./exchangeCurrencyTicketDetail.vue?vue&type=template&id=7ca4a7ba&lang=pug"
import script from "./exchangeCurrencyTicketDetail.vue?vue&type=script&lang=js"
export * from "./exchangeCurrencyTicketDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports